import { Flex } from 'reflexbox';
import styled, { CSSProperties } from 'styled-components';

export const FlexGap = styled(Flex)<{ gap?: number; position?: CSSProperties['position'] }>`
	${({ gap }) => gap && `gap: ${gap}px;`}
	${({ position }) => position && `position: ${position};`}
`;
